import React from 'react';

import cn from 'classnames';

import { Chip } from '@shared/ui';
import { formatIsoDate } from '@widgets/Comments/lib/helpers';

import cls from './DateChip.module.css';

interface IDateChipProps {
    datetime: string;
    className?: string;
}
export const DateChip = ({ datetime, className }: IDateChipProps) => {
    const formattedDate = formatIsoDate(datetime, 'DD MMMM');
    return (
        <Chip
            containerStyles={cls.DateChipContainer}
            textStyles={cls.DateChipText}
            textContent={formattedDate}
        />
    );
};
